import { apiClient } from './client'

export type ThumbsFeedback = 'Up' | 'Down'

export type AiFeedbackMessage = {
  role: string
  content?: string | null
}

export type AiFeedbackConversationMessage = {
  role: string
  content: string
  interactionId?: string | null
  timestamp: string
}

export type AiFeedbackConversation = {
  id: string
  title: string
  messages: AiFeedbackConversationMessage[]
  createdAt: string
  updatedAt: string
}

export type AiFeedbackUsage = {
  promptTokens: number
  completionTokens: number
  totalTokens: number
}

export type AiFeedbackItem = {
  id: string
  userId: string
  channel: string
  agentRole: string
  systemPromptId?: string | null
  model?: string | null
  messages: AiFeedbackMessage[]
  response?: AiFeedbackMessage | null
  savedConversation?: AiFeedbackConversation | null
  displayedResponse?: AiFeedbackConversationMessage | null
  usage?: AiFeedbackUsage | null
  subscriptionTier: string
  subscriptionStatus: string
  durationMs?: number | null
  feedback: ThumbsFeedback
  feedbackAt?: string | null
  feedbackComment?: string | null
  feedbackReviewedAt?: string | null
  feedbackReviewedByUserId?: string | null
  createdAt: string
}

export type AiFeedbackListResponse = {
  items: AiFeedbackItem[]
}

export type AiFeedbackListOptions = {
  feedback?: ThumbsFeedback
  reviewed?: boolean
  limit?: number
}

export async function getAiFeedback(options: AiFeedbackListOptions = {}) {
  const { data } = await apiClient.get<AiFeedbackListResponse>('/api/admin/ai-feedback', {
    params: options
  })
  return data
}

export async function markAiFeedbackReviewed(interactionId: string) {
  const { data } = await apiClient.post<AiFeedbackItem>(`/api/admin/ai-feedback/${interactionId}/review`, {})
  return data
}
